import SimpleText from './SimpleText';
import ConfirmModal from './ConfirmModal';

export default {
  SimpleText,
  ConfirmModal,
};
